module.exports = __webpack_public_path__ + "img/building.f7d3b034.png";